import React, { useState, useEffect } from 'react';
import CreditPlanFlow from './CreditPlanFlow';
import demoPlanData from '../../data/demoPlan.json';
import './DemoPlanFlow.css';

const DemoPlanFlow = () => {
  const [assessmentData, setAssessmentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      // Load the demo plan data from JSON
      // The JSON should match the structure of an assessment document
      const data = demoPlanData;
      
      // Ensure the data has the expected structure
      if (!data.creditPlan || !data.creditPlan.planStructure) {
        throw new Error('Demo plan data is missing creditPlan.planStructure');
      }
      
      setAssessmentData(data);
      setLoading(false);
    } catch (err) {
      console.error('Error loading demo plan data:', err);
      setError(err.message);
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="demo-plan-flow loading">
        <div className="loading-content">
          <div className="loading-spinner"></div>
          <h2>Loading Demo Plan...</h2>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="demo-plan-flow error">
        <div className="error-content">
          <h2>⚠️ Error Loading Demo Plan</h2>
          <p>{error}</p>
          <p>Please ensure the demoPlan.json file contains valid assessment data.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="demo-plan-flow">
      <div className="demo-banner">
        <div className="demo-banner-content">
          <span className="demo-badge">DEMO</span>
          <span className="demo-message">
            This is a demo plan. You can interact with it, but changes will not be saved.
          </span>
        </div>
      </div>
      <CreditPlanFlow 
        assessmentData={assessmentData} 
        isDemo={true}
      />
    </div>
  );
};

export default DemoPlanFlow;

